<template>
  <div class="w-full p-6">
    <!-- Header Section -->
    <div class="mb-6">
      <div class="flex justify-between items-center mb-2">
        <h1 class="text-2xl font-bold text-blue-900">Chatbot</h1>
      </div>
      <p class="text-gray-600">AI-powered assistant for airport management tasks</p>
    </div>

    <!-- Chatbot Interface -->
    <div class="chatbot-wrapper bg-white rounded-lg shadow-lg overflow-hidden">
      <ChatbotInterface v-if="userData && userData?.id"
        :userData="userData"
        :environment="currentEnv"
        :userId="userData?.id"
        class="h-full"/>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { BusinessRole } from '@/types/businessRole';
import { ChatbotEnv } from '@/types/chatbotEnv';
import ChatbotInterface from './chatbot/ChatbotInterface.vue';

export interface UserData {
  id?: string;
  name?: string;
  avatar?: string | null;
  business_role?: string;
}

export default defineComponent({
  name: 'ChatbotView',
  components: {
    ChatbotInterface
  },
  props: {
    userData: {
      type: Object as PropType<UserData>,
      default: () => ({
        name: 'User',
        avatar: null,
        business_role: BusinessRole.PLANNER
      })
    }
  },
  setup() {
    // Current environment is always GLOBAL for this page
    const currentEnv = ChatbotEnv.GLOBAL;

    return {
      currentEnv
    };
  }
});
</script>

<style scoped>
.chatbot-wrapper {
  height: calc(100vh - 220px); /* Adjust based on the header height and margins */
  min-height: 500px;
  max-height: 800px;
  box-shadow: 0 4px 20px rgba(0, 0, 145, 0.1);
  border-radius: 12px;
  transition: box-shadow 0.3s ease;
}

.chatbot-wrapper:hover {
  box-shadow: 0 6px 24px rgba(0, 0, 145, 0.15);
}

/* For smaller screens */
@media (max-height: 900px) {
  .chatbot-wrapper {
    height: calc(100vh - 180px);
  }
}

/* For mobile screens */
@media (max-width: 640px) {
  .chatbot-wrapper {
    height: calc(100vh - 160px);
    min-height: 400px;
  }
}
</style>